import { Card, Skeleton, Table, Typography } from 'antd';
import { ColumnType } from 'antd/es/table';
import React, { memo } from 'react';
import { ArchiveNode, Statuses } from '../admin-knowledge-base.type';
import dayjs from 'dayjs';
import { useDeletedEntities } from '../hooks/use-deleted-entities';
import { LeftCircleOutlined } from '@ant-design/icons';
import Space from 'antd/lib/space';
import { types } from '../admin-knowledge-base.constants';
import Button from '/react4xp/mixins/ui/button/button';
import { Types } from '/react4xp/parts/knowledge-base-common/knowledge-base-common.type';

interface DeletedMaterialsProps {
    goBack: () => void;
    roles: string[];
    privileges: string[];
}

const DeletedMaterials = memo(({ goBack, roles, privileges }: DeletedMaterialsProps) => {
    const { isLoading, items, restore } = useDeletedEntities();

    const columns: ColumnType<ArchiveNode>[] = [
        {
            title: 'Тип',
            key: 'type',
            dataIndex: 'type',
            render: (value: Types) => types[value],
        },
        {
            title: 'Наименование',
            key: 'title',
            dataIndex: 'title',
        },
        {
            title: 'Дата удаления',
            dataIndex: 'updatedAt',
            key: 'updatedAt',
            render: (value) => dayjs(value).format('DD.MM.YYYY'),
        },
        {
            title: 'Действия',
            key: 'actions',
            render: (_, record: ArchiveNode) =>
                record.isDeleted ? (
                    <Button
                        onClick={() =>
                            restore(record.key, record.isLeaf ? Statuses.DRAFT : Statuses.PUBLISH)
                        }
                    >
                        Восстановить
                    </Button>
                ) : null,
        },
    ];

    return (
        <Card className="knowledge-base-admin">
            <Space align="baseline">
                <LeftCircleOutlined
                    onClick={goBack}
                    style={{ cursor: 'pointer', fontSize: '1.5rem' }}
                />
                <Typography.Title level={4}>Удаленные материалы</Typography.Title>
            </Space>
            {isLoading ? (
                <Skeleton />
            ) : (
                <Table
                    columns={columns}
                    dataSource={items}
                    loading={isLoading}
                    scroll={{ x: 'max-content' }}
                    pagination={false}
                />
            )}
        </Card>
    );
});

export default DeletedMaterials;
